import { useEffect, useContext } from 'react';
import { AuthContext } from '../../contexts/AuthenticationContext';
import { getConfig } from '../../../config/envconfig';

export const Login = () => {
    const { login } = useContext(AuthContext);
    useEffect(() => {
        login(getConfig());
    });
    return <></>;
};

export default Login;
